<script setup>
import { onBeforeUnmount, onMounted, ref, watch } from 'vue'
import { useDocumentVisibility, useEventListener } from '@vueuse/core'
import { throttle } from 'radash'
import { useUserStore } from '@/stores/user.js'

const userStore = useUserStore()

let timer = null

const visibility = useDocumentVisibility()

const inactivitySeconds = ref(5 * 60)

const userActivityDetected = () => {
  userStore.userIsActive = true

  clearTimeout(timer)
  startInactivityTimer()
}

watch(visibility, (visibility) => {
  if (visibility === 'visible') {
    userActivityDetected()
  }
})

const startInactivityTimer = () => {
  timer = setTimeout(() => {
    userStore.userIsActive = false
  }, inactivitySeconds.value * 1000)
}

const throttledUserActivityDetected = throttle({ interval: 500 }, userActivityDetected)

onMounted(() => {
  useEventListener(document, 'mousemove', throttledUserActivityDetected)
  useEventListener(document, 'keydown', throttledUserActivityDetected)
  useEventListener(document, 'scroll', throttledUserActivityDetected)
  useEventListener(document, 'click', throttledUserActivityDetected)

  startInactivityTimer()
})

onBeforeUnmount(() => {
  clearTimeout(timer)
})
</script>

<template>
  <div/>
</template>
